import { useTranslation } from 'react-i18next';

import ModalConfirmation from '../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { useDeleteCampaignMutation } from './hooks/useCampaignMutation';
import { Modal } from '../../../boardSetup/components/Modals/Modal.jsx';

export const ConfirmDeleteModal = ({
  uuid,
  name,
  showDeleteModal,
  setShowDeleteModal,
}) => {
  const { t } = useTranslation('campaigns');
  const { deleteCampaignMutation } = useDeleteCampaignMutation();

  return (
    <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
      <ModalConfirmation
        onSave={() => {
          deleteCampaignMutation(uuid);
          setShowDeleteModal(false);
        }}
        onCancel={() => setShowDeleteModal(false)}
        header={t('deleteModal.deleteHeader')}
        body={t('deleteModal.deleteBody', { campaignName: name })}
        variant={'containedRed'}
        answer={t('deleteModal.deleteAnswerValue')}
        actionTitle={t('deleteModal.deleteTooltip')}
        submitText={t('deleteModal.deleteButton')}
        cancelText={t('deleteModal.cancelButton')}
      />
    </Modal>
  );
};
